


















































































































































































































import { Vue } from "../../constants/constants";
import { staticContent } from "../../localisation/detect-lang";
export default Vue.component("resume-order-modal", {
  data() {
    return {
      staticContent,
      payment: {
        payment: "",
        cardUUID: null
      }
    };
  },

  props: {},
  mounted() {
    this.$store.dispatch('GET_USER_CREDIT_CARDS');
  },
  computed: {
    bindConditionalClasses() {
      return this.$root.bindConditionalClasses;
    },
    resumeOrderState() {
      return this.$store.state.resumeOrder;
    },
    resumeOrderUUID() {
      return this.$root.resumeOrder.uuid;
    },
    resumeOrder() {
      return this.$root.resumeOrder;
    },
    creditCards(){
      return this.$store.state.creditCards
    },
    addressForm() {
      return {
        apartmentNumber: this.resumeOrder.data.orderDeliveryAddress
          ? this.resumeOrder.data.orderDeliveryAddress.data.apartmentNumber
          : null,
        floor: this.resumeOrder.data.orderDeliveryAddress
          ? this.resumeOrder.data.orderDeliveryAddress.data.floor
          : null,
        address: this.resumeOrder.data.orderDeliveryAddress
          ? this.resumeOrder.data.orderDeliveryAddress.data.address
          : null,
        buildingNumber: this.resumeOrder.data.orderDeliveryAddress
          ? this.resumeOrder.data.orderDeliveryAddress.data.buildingNumber
          : null
      };
    }
  },
  methods: {
    modalToggler(modalId, method) {
      return this.$root.modalToggler(modalId, method);
    },
    selectOrderToCancel(orderUUID) {
      this.$root.selectOrderToCancel(orderUUID);
    },
    resumeOrderAddress() {
      return this.$store.dispatch("UPDATE_ORDER_ADDRESS", [
        this.resumeOrderUUID,
        this.addressForm
      ]);
    },
    resumeOrderPaymentCash() {
      this.payment.payment = "CASH_ON_DELIVERY";
      this.payment.cardUUID=null;
      return this.$store.dispatch("UPDATE_ORDER_PAYMENT", [
        this.resumeOrderUUID,
        this.payment
      ]);
    },
    resumeOrderPaymentCredit() {
      this.payment.payment = "CREDIT_CARD";
      return this.$store.dispatch("UPDATE_ORDER_PAYMENT", [
        this.resumeOrderUUID,
        this.payment
      ]);
    }
  }
});
